import { GUID } from '@babylonjs/core';
import { Query, World } from 'miniplex';

import { Entity } from '.';

export const createEntityFactory =
  <E extends Entity>(world: World<E>) =>
  <T extends Omit<E, 'entityId'>>(components?: T) => {
    const entity = world.add({
      ...({} as E), // HACK: to avoid ts:2379
      entityId: GUID.RandomId(),
      ...components,
    });

    return entity as unknown as T & Pick<Entity, 'entityId'>;
  };

export const clearArchetype = <E>(archetype: Query<E>) => {
  archetype.clear();
  archetype.onEntityAdded.clear();
  archetype.onEntityRemoved.clear();
};
